import React from 'react';

import './ItusLogo.scss';
import logo from '../../styles/assets/icons/ITUS_black_hand.svg'

export function ItusLogo() {
  return (
    <div className='ItusLogo'>
      <img className="ItusLogo__logo" src={logo} alt='itus-logo' />
      <h1 className='ItusLogo__logo-text'>I told you so!</h1>
      <div className='ItusLogo__beta'>(beta)</div>
    </div>
  );
}
